/**
 * @typedef {import('react-reconciler').Source} Source
 */

/**
 * @param {Source} source
 */
export function getPathToSource(source) {
  var _source$columnNumber = source.columnNumber,
    columnNumber = _source$columnNumber === void 0 ? 1 : _source$columnNumber,
    fileName = source.fileName,
    _source$lineNumber = source.lineNumber,
    lineNumber = _source$lineNumber === void 0 ? 1 : _source$lineNumber;
  return "".concat(fileName, ":").concat(lineNumber, ":").concat(columnNumber);
}